import { createSvg } from '@r1-frontend/ui-react/components/svg/createSvg';

const Close = (
    {
        strokeWidth = 1.5,
    },
): JSX.Element => {
    return (
        <g id={'guts'}>
            <path
                d='M7 17L17 7'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
                stroke='currentColor'
            />
            <path
                d='M17 17L7 7'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
                stroke='currentColor'
            />
        </g>
    );
};

export default createSvg(
    Close,
    'close',
);
